var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageDictionary = function SvgMypageDictionary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M7.45 21.75h14.3V2.25H7.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    fillRule: "evenodd",
    d: "M5.795 21.75H7.45V2.25h-5.2v15.955a3.546 3.546 0 0 0 3.545 3.545M17.2 9.4l1.95 1.95v-9.1h-3.9v9.1z",
    clipRule: "evenodd"
  })));
};
export default SvgMypageDictionary;